import React from 'react';
import { Chip, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
function Breadcrumb({ link, label, ...props }) {
    return (React.createElement(Link, { component: RouterLink, to: link ? link : '#', underline: "none" },
        React.createElement(Chip, { label: React.createElement(Typography, { variant: "inherit", sx: { height: '18px', cursor: link ? 'pointer' : 'default' }, color: "white" }, label), variant: "outlined", sx: {
                border: 0,
                '& .MuiChip-icon': {
                    color: 'white',
                },
            }, ...props })));
}
export default Breadcrumb;
